import React from "react";
import { Card, CardBody, CardHeader, } from "reactstrap";
import ReportFooter from "../../screens/common/ReportFooter";
import ReportHeader from "../../screens/common/ReportHeader";
import ReactToPrint from "react-to-print";
import "./viewqr.css";
import $ from "jquery";


export default class ViewQrAfter extends React.Component {
componentDidMount() {
// <script type="text/javascript">
var query = {
cht: "qr",
choe: "UTF-8",
chs: "500x500",
chld: "30",
chl: `estimateID="";vin=${localStorage.getItem(
"selectedFile"
)};make="";model="";color=""`,
};
var url = "https://chart.apis.google.com/chart?" + $.param(query);
$("#linkafter").attr("src", url);
}

render() {
return (
<>

<div className="animated fadeIn overflow-hidden">
    <div xs="12" sm="12" className="p-2">
        <Card>
            <CardHeader>
                <ReactToPrint
                    trigger={() =>
                {
                document.title = localStorage.getItem("selectedFile");
                return (
                <button className="glass btn btn-lg btn-danger pull-right">
                <i className="fa fa-print" />
                &nbsp; Print PDF
                </button>
                );
                }}
                content={() => this.componentRef}
                />
                <small> VIN Number : {localStorage.getItem("selectedFile")}</small>
            </CardHeader>
        </Card>
        <div
            className="container"
            id="divIdToPrint"
            ref={(el) =>
            (this.componentRef = el)}
            style={{ padding: 0 }}
            >
            <div className="row page-break-top">
                <div className="col-sm-12 main-col-full">
                    <Card>
                        <CardBody className="p-0">
                            <div className="newFormatReport">
                                <ReportHeader is_view_qr_page={true} />
                                <div className="p-0">
                                    <img id="linkafter" className="m-auto w-100" />
                                </div>
                            </div>
                        </CardBody>
                        <ReportFooter />
                    </Card>
                </div>
            </div>
        </div>
    </div>
</div>
</>
);
}
}